var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNlIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.622 8.522a10.004 10.004 0 0 1 18.756 0H2.622Z",
  fill: "#AE1C28"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.622 15.478a10.004 10.004 0 0 0 18.756 0H2.622Z",
  fill: "#21468B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.622 8.522A9.978 9.978 0 0 0 2 12c0 1.223.22 2.395.622 3.478h18.756A9.978 9.978 0 0 0 22 12c0-1.223-.22-2.395-.622-3.478H2.622Z",
  fill: "#FFF"
})));
export { SvgNlIcon as ReactComponent };
export default __webpack_public_path__ + "0a287c118a2a70cc458293a34c3002dd.svg";